import "./Navbar.css";

import React, { useContext } from "react";

import { UserContext } from "../../auth/UserProvider";

import Logo from "./logo.png";

const Navbar = () => {
  const user = useContext(UserContext);
  return (
    <div className="navbar" style={{ zIndex: "1000" }}>
      {" "}
      <nav
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        {" "}
        <img src={Logo} alt="Logo" className="Logo" />
        <div
          className="title"
          style={{
            flexGrow: 2,
          }}
        >
          Templates / <text className="BoldTitle">Google Ad</text>
        </div>
        {user && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div id="circle"></div>
            <div
              className="accountname"
              style={{ marginLeft: 30, marginRight: 30 }}
            >
              {user.displayName}
            </div>
            <div className="arrow"></div>
          </div>
        )}
      </nav>
    </div>
  );
};

export default Navbar;
